import {TweenMax, Circ, Power2} from 'gsap';

export class Contact {
    private readonly contactBtns: NodeList = document.querySelectorAll<HTMLElement>(".js-contact-btn");
    private readonly contactPopup: HTMLElement = <HTMLElement>document.querySelector(".js-contact-popup");
    private readonly body: HTMLElement = <HTMLElement>document.querySelector("body");
    private isOpened: boolean = false;

    constructor() {
        if (this.contactBtns.length > 0) {
            // @ts-ignore
            for (let btn of this.contactBtns)
                this.init(btn);
        }
    }

    private init(contactBtn: HTMLElement): void {
        document.addEventListener('keydown', (ev) => {
            let isEscape = false;
            if ("key" in ev) {
                isEscape = (ev.key === "Escape" || ev.key === "Esc");
            } else {
                // @ts-ignore
                isEscape = (ev.keyCode === 27);
            }

            if (isEscape) {
                this.close();
            }
        });

        contactBtn.addEventListener('click', (ev) => {
            ev.preventDefault();

            if (this.isOpened) {
                this.close();
            } else {
                this.open();
            }
        });
    }

    private open(): void {
        this.isOpened = true;
        this.body.classList.add('is-locked');

        TweenMax.to(this.contactPopup, 0.6, {
            y: '0%',
            force3D: true,
            ease: Circ.easeOut,
            onComplete: () => {
                this.contactPopup.classList.add('c-contact-popup--opened');
            }
        });
    }

    private close(): void {
        this.isOpened = false;
        this.body.classList.remove('is-locked');
        this.contactPopup.classList.remove('c-contact-popup--opened');

        TweenMax.to(this.contactPopup, 0.5, {
            y: '100%',
            ease: Power2.easeOut
        });
    }

}
